import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const steps = [
  { num: "01", title: "Understand the Business", desc: "We align on the format, outlet type, audit requirement and the operational context before the site visit begins." },
  { num: "02", title: "Conduct the Audit", desc: "We review hygiene practices, kitchen conditions, storage, staff behavior and food safety controls during the visit." },
  { num: "03", title: "Share Findings", desc: "We provide clear observations, risk areas and practical recommendations that are easy to understand and prioritize." },
  { num: "04", title: "Support Improvement", desc: "Where required, we support follow-up checks, readiness improvement and FSSAI licensing guidance for eligible establishments." },
];

export default function Process() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="process" className="py-12 md:py-20 bg-[#16231A]" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-10"
        >
          <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#7CA63A] mb-4 block">Our Process</span>
          <h2 className="font-['Outfit'] text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight leading-[1.2] mb-4">
            How We Work
          </h2>
          <p className="text-[#8BA18F] max-w-2xl mx-auto leading-relaxed">
            Our process is simple, structured and easy for business owners, outlet managers and kitchen teams to act on.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 25 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 * i }}
              className="relative bg-[#1E2E22] border border-[#2D4233] rounded-2xl p-8 group hover:border-[#7CA63A] transition-all duration-300"
              data-testid={`process-step-${i}`}
            >
              <span className="font-['Outfit'] text-5xl font-bold text-[#7CA63A]/20 absolute top-4 right-6 group-hover:text-[#7CA63A]/40 transition-colors duration-300">
                {s.num}
              </span>
              <div className="w-10 h-10 bg-[#7CA63A] rounded-full flex items-center justify-center mb-5">
                <span className="text-white font-['Outfit'] font-bold text-sm">{i + 1}</span>
              </div>
              <h3 className="font-['Outfit'] text-lg font-bold text-white mb-2">{s.title}</h3>
              <p className="text-sm text-[#8BA18F] leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
